import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListContentApps from '../../components/content/list-apps.component';

const ContentAppsView = () => {
  const pageTitle = 'Manage Channels / Channel Settings';

  return (
    <AppLayout pageTitle={pageTitle} showFilter>
      <ListContentApps />
    </AppLayout>
  );
};

export default ContentAppsView;
